import React from 'react';
import styles from './SwitchList.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const SwitchList = ({ options, activeKey, onSelect, classNames }) => {

    const { t } = useTranslation();

    return <div className={cx(styles.container, classNames)}>
        {options.map(([key, value], index) =>
            <button
                key={`switch-${key}-${index}`}
                className={cx(styles.switch, { [styles.active]: key === activeKey })}
                onClick={() => onSelect(key)}
                aria-pressed={key === activeKey}
            >
                {t(value)}
            </button>)}
    </div>
}

export default SwitchList;